import { Component, OnInit, OnDestroy, AfterViewInit } from "@angular/core";
import { ActivatedRoute, Router, NavigationEnd } from "@angular/router";
import { Location } from "@angular/common";
import { DeviceDetectorService } from "ngx-device-detector";
import { SeoService } from "../../../data/seo/seo-service.service";
import { AuthorP, PostContentP, PostP } from "../../../data/blog-client-api";
import { BlogDataRestService } from "../../../data/blog/blog-data-rest.service";
import { Subscription } from "rxjs";
import { BasePageComponent } from "../../commons/base-page/base-page.component";
import { HelpersService } from "../../../core/helpers/helpers.service";

declare var videojs: any;
declare var $: any;

@Component({
  selector: "app-blog-detail",
  templateUrl: "./blog-detail.component.html",
  styleUrls: ["./blog-detail.component.css"],
})
export class BlogDetailComponent
  extends BasePageComponent
  implements OnDestroy, AfterViewInit, OnInit
{
  blogID: number;
  blogContents: PostContentP[] = [];
  selectedBlogContent: PostContentP = {};
  blog: PostP = {};
  authorBlogGroup: AuthorP = { id: -1, name: "Diğer Yazılar", contents: [] };
  player: any;
  isPlay: boolean = false;
  isDesktop: boolean;
  isMobile: boolean;
  pageUrl: string;
  isBlog: boolean = true;
  routerSubs: Subscription;

  constructor(
    helpers: HelpersService,
    private route: ActivatedRoute,
    private blogService: BlogDataRestService,
    private deviceService: DeviceDetectorService,
    private seoService: SeoService,
    private router: Router
  ) {
    super(helpers);

    this.isDesktop = deviceService.isDesktop();
    this.isMobile = deviceService.isMobile();
    this.routerSubs = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.getBlogContents();
      }
    });
  }

  ngAfterViewInit() {
    this.getBlogContents();
  }

  getBlogContents() {
    this.blogID = +this.route.snapshot.paramMap.get("id");

    this.blogService.getBlogById(this.blogID).subscribe((data) => {
      this.blog = data;

      this.blogContents = this.blog.postContents.sort(
        (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
      );
      this.selectedBlogContent = this.blogContents[0];
      this.getQueryParams();
      this.initPlayer();
      this.setSeoInfos();
    });
  }

  setSeoInfos() {
    this.seoService.generateTags({
      title: this.selectedBlogContent.title,
      description: this.selectedBlogContent.description,
      image: this.blog.posterUrl,
      slug: "blogDetail/" + this.blogID,
      url: this.router.url,
    });
  }

  initPlayer() {
    if (!this.player) {
      this.player = videojs("audio-player", {
        controls: true,
        fluid: false,
        controlBar: {
          playToggle: {
            replay: true,
          },
          // volumePanel: {
          //   inline: false,
          // },
        },
      });
    }
    this.player.poster(this.blog.posterUrl);
    this.player.src([
      { type: "audio/mp3", src: this.selectedBlogContent.mediaUrl },
    ]);

    this.player.on("playing", () => {
      this.isPlay = true;
    });

    this.player.on("pause", () => {
      this.isPlay = false;
    });

    var thiz = this;

    this.player.one("loadedmetadata", function () {
      thiz.overlayPlayer();
    });

    $(document).keyup(function (e) {
      if (e.which === 37 && thiz.player) {
        //key press left arrow
        thiz.player.currentTime(thiz.player.currentTime() - 10);
      }

      if (e.which === 39 && thiz.player) {
        //key press right arrow
        thiz.player.currentTime(thiz.player.currentTime() + 10);
      }
    });

    let bigPlayButtonEl = this.player.getChild("bigPlayButton").el();
    bigPlayButtonEl.setAttribute("id", "blog-player-big-volume");
    bigPlayButtonEl.setAttribute("title", "Play Blog");
    bigPlayButtonEl.style.color = "rgba(250,0,0,0.9)";

    document.querySelector(
      "#blog-player-big-volume .vjs-icon-placeholder"
    ).outerHTML = '<i class="fa fa-volume-up"></i>';
    document.querySelector(
      "#blog-player-big-volume .vjs-control-text"
    ).outerHTML =
      '<span class="vjs-control-text" aria-live="polite">Play Blog</span>';
  }

  jumpButton: HTMLElement;
  jumpBackButton: HTMLElement;
  overlayPlayer() {
    var thiz = this;
    this.player.overlay({
      overlays: [
        {
          content: `
        <div id="podcast-jump-right" class="jump-on-10">
          <i class="fa fa-repeat" style="color: rgba(199, 199, 199, 0.6)"></i>
          <div class="time-of-jump">10</div>
        </div>

                  `,
          align: "right",
          start: 0,
          end: this.isDesktop ? this.player.duration() : 0,
        },
        {
          content: `
        <div id="podcast-jump-left" class="jump-on-10">
          <i class="fa fa-rotate-left" style="color: rgba(199, 199, 199, 0.6)"></i>
          <div class="time-of-jump">10</div>
         </div>
        `,
          align: "left",
          start: 0,
          end: this.isDesktop ? this.player.duration() : 0,
        },
      ],
    });

    setTimeout(() => {
      this.jumpButton = document.getElementById("podcast-jump-right");
      this.jumpBackButton = document.getElementById("podcast-jump-left");

      this.jumpButton.addEventListener("click", (event) => {
        this.player.currentTime(this.player.currentTime() + 10);
      });

      this.jumpBackButton.addEventListener("click", (event) => {
        this.player.currentTime(this.player.currentTime() - 10);
      });
    }, 100);
  }

  timer: any;

  mouseMoved() {
    if (this.isDesktop && !!this.player) {
      if (this.timer && this.jumpButton && this.jumpBackButton) {
        clearTimeout(this.timer);
        this.jumpButton.classList.remove("jump-on-10-hidden");
        this.jumpBackButton.classList.remove("jump-on-10-hidden");
      }

      this.timer = setTimeout(() => {
        this.jumpButton.classList.add("jump-on-10-hidden");
        this.jumpBackButton.classList.add("jump-on-10-hidden");
      }, 2200);
    }
  }

  routeSubs: Subscription;
  getQueryParams() {
    this.routeSubs = this.route.queryParamMap.subscribe((queryParams) => {
      let id = +queryParams.get("content");
      this.setSeoInfos();
      if (!!id) {
        this.selectedBlogContent =
          this.blog.postContents[
            this.blog.postContents.findIndex((item) => item.id == id)
          ];
      }
      this.pageUrl = document.URL;
    });
  }

  changeSource(blogContent: PostContentP) {
    if (this.isPlay && this.selectedBlogContent.id == blogContent.id) {
      this.player.pause();
    } else {
      if (this.selectedBlogContent.id != blogContent.id) {
        this.player.src([{ type: "audio/mp3", src: blogContent.mediaUrl }]);
      }
      setTimeout(() => {
        this.player.play();
      }, 200);
    }
    this.router.navigate(["/blogDetail/" + this.blog.id]);
    this.selectedBlogContent = blogContent;
  }

  ngOnDestroy() {
    if (!!this.player) {
      this.player.dispose();
    }
    if (this.routerSubs) {
      this.routerSubs.unsubscribe();
    }
  }

  locationBack() {
    this.router.navigate(["dashboard/-2/blog"]);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/views/blog/blog-detail/blog-detail.component.ts